import React from 'react'
import { Heading } from 'components/Heading'
import GithubSlugger from 'github-slugger'
import { prepareData } from 'utils/googleData'
import Link from 'components/Link'

const headingSize = {
    sm: 'text-2xl md:text-[30px]',
    md: 'text-3xl md:text-[48px]',
    lg: 'text-4xl md:text-[64px]',
}

const contentSize = {
    full: 'w-full',
    sm: 'max-w-[600px]',
    md: 'max-w-[800px]',
    lg: 'max-w-[1200px]',
}

export function HighlightBox(props) {
    const { enable, title, features, titleSize = 'sm', className = '', size = 'full' } = prepareData({ props })

    if (enable?.toLowerCase?.() === 'false' && !process.env.RENDER_DISABLED_COMPONENTS) {
        return <></>
    }

    const slugger = new GithubSlugger()
    const id = slugger.slug(title)

    return (
        <section className={`my-10 sm:mt-12 sm:mb-20 ${className} dark:bg-gray-900`}>
            {title && (
                <Heading
                    id={id}
                    hideCopy
                    as="h2"
                    className={`mb-16 text-center ${headingSize[titleSize]} dark:text-gray-200`}
                >
                    {title}
                </Heading>
            )}
            <div
                className={`grid grid-cols-1 gap-4  md:grid-cols-2 lg:grid-cols-2 lg:items-center lg:gap-8 lg:space-y-0 lg:p-12 ${contentSize[size]} mx-auto`}
            >
                {features.map((feature, index) => (
                    <div
                        key={index}
                        className={` border-gray-accent-light hover:bg-gray-accent-light dark:border-gray-accent-dark dark:hover:bg-gray-accent-dark`}
                    >
                        <Link
                            to={feature.url}
                            key={index}
                            className={`dark:hover:shadow-lg/50 block rounded-lg transition-shadow duration-300 hover:shadow-lg ${
                                features.length % 3 === 1 && index === features.length - 1 ? 'col-start-2' : ''
                            }`}
                        >
                            <div className="dark:bg-gray-800 dark:text-gray-300 relative flex flex-col items-center justify-center px-2 py-8 text-center">
                                <h5 className="text-xl font-bold text-primary  dark:text-primary-dark">
                                    {feature.title}
                                </h5>
                                <p className="dark:text-gray-400 mt-2">{feature.subtitle}</p>
                                <p className="dark:text-gray-500 mt-4 text-sm">{feature.description}</p>
                            </div>
                        </Link>
                    </div>
                ))}
            </div>
        </section>
    )
}

export default HighlightBox
